/**
 * THE pinpoint glyph — the location mark in the ZIP Code trigger
 * (`molecules/zip-code`). Follows `close-glyph.ts`'s pattern: constants, not a
 * component, so a Server Component and a "use client" leaf can each render it
 * at their own size without importing one another. `fill="currentColor"` at
 * every call site.
 *
 * ⚠ THIS IS NOT AN ICON LAYER — see close-glyph.ts's header for what that
 * means. A further asset still has to make its own argument.
 *
 * FUSION ECLIPSE `pinpoint` (`c769d44bba2291e8d783db6e321a002e9095f962`),
 * local node `15829:51606` in `FDnUrbSC3dd0XIk5zNQmAR` — the "ZIP code
 * change" instance `I13337:12723;15133:24402`. 24x24, Figma fill
 * `#F4F7FC` dropped for `currentColor`.
 */
export const PINPOINT_GLYPH_VIEWBOX = "0 0 24 24";

export const PINPOINT_GLYPH_PATH =
  "M12.0021 2.00024C10.5157 1.98807 9.06114 2.43984 7.83433 3.29475C6.60752 " +
  "4.14967 5.6673 5.36666 5.13997 6.78216C4.61264 8.19765 4.52355 9.74365 " +
  "4.88476 11.2122C5.24597 12.6808 6.04005 14.0015 7.1603 14.9966C7.78759 " +
  "15.594 8.34533 16.263 8.82236 16.9904H8.82634L11.5968 21.7381C11.6328 " +
  "21.8166 11.6901 21.8829 11.7619 21.9293C11.8337 21.9757 11.9171 22.0003 " +
  "12.0021 22C12.0875 21.9992 12.1709 21.9738 12.2427 21.9267C12.3145 " +
  "21.8797 12.3717 21.8129 12.4079 21.7341L15.176 16.9851C15.6552 16.2601 " +
  "16.2141 15.5932 16.8419 14.9974C17.9613 14.002 18.7547 12.6815 19.1155 " +
  "11.2134C19.4763 9.74522 19.3873 8.19975 18.8603 6.78467C18.3333 5.36959 " +
  "17.3937 4.15269 16.1677 3.29751C14.9417 2.44233 13.4881 1.98921 12.0021 " +
  "2.00024ZM16.4119 11.1049C16.3786 11.1913 16.3421 11.2764 16.3036 " +
  "11.3601C15.9231 12.1954 15.3159 12.9023 14.5537 13.3976C13.7916 13.8929 " +
  "12.9062 14.1558 12.0021 14.1553C11.3786 14.1628 10.7596 14.0442 10.1814 " +
  "13.8063C9.60318 13.5684 9.07712 13.216 8.63358 12.7696C8.19003 12.3231 " +
  "7.83794 11.7915 7.5976 11.2054C7.35726 10.6194 7.23343 9.99057 7.23343 " +
  "9.35544C7.23343 8.72031 7.35726 8.09145 7.5976 7.50538C7.83794 6.91932 " +
  "8.19003 6.38767 8.63358 5.94121C9.07712 5.49476 9.60318 5.14238 10.1814 " +
  "4.90452C10.7596 4.66665 11.3786 4.54804 12.0021 4.55552C12.4795 4.55518 " +
  "12.9542 4.62796 13.4102 4.77147C13.559 4.81799 13.7039 4.87251 13.8455 " +
  "4.93299C14.98 5.41872 15.8848 6.33452 16.3687 7.48697C16.851 8.63998 " +
  "16.8666 9.94032 16.4119 11.1049Z";
